/**
 * Records which upsell sold an item, as a cart attribute the order keeps
 * (admin: "Additional details"). One attribute per variant:
 *   _upsell_<variant id> = "Complete your ride, cart drawer: Plus 35 MTB Stem (Black / 40mm)"
 *
 * Upsell cards (PDP Combine With, cart Complete your ride) carry
 * data-upsell-source="<label>" on their <product-form> or <quick-add-modal>.
 * A submit from inside one is noted here, before product-form.js sends it;
 * the next cartUpdate writes the record. A cart attribute, not a line item
 * property, so the same variant added from its own product page merges into
 * the same cart line instead of splitting it.
 *
 * Records follow the cart: the same cartUpdate pass blanks (deletes) any
 * _upsell_ attribute whose variant has left it. A cart without records skips
 * the pass entirely, so shoppers who never use an upsell pay no extra request.
 *
 * Loaded from snippets/cart-assets.liquid, which may render twice on a page.
 */
(function () {
  if (window.e13UpsellSource) return;
  window.e13UpsellSource = true;

  const script = document.currentScript;
  let hasRecords = script ? script.dataset.hasRecords === 'true' : true;
  const pending = new Map(); // variant id -> upsell label

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      const host = form.closest && form.closest('[data-upsell-source]');
      const variantId = host && form.elements.id && form.elements.id.value;
      if (variantId) pending.set(String(variantId), host.dataset.upsellSource);
    },
    true
  );

  subscribe(PUB_SUB_EVENTS.cartError, () => pending.clear());

  subscribe(
    PUB_SUB_EVENTS.cartUpdate,
    debounce(() => {
      if (!pending.size && !hasRecords) return;
      fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => {
          const items = new Map(cart.items.map((item) => [String(item.variant_id), item]));
          const attributes = {};
          pending.forEach((label, variantId) => {
            const item = items.get(variantId);
            if (!item) return;
            const name = item.product_title + (item.variant_title ? ` (${item.variant_title})` : '');
            attributes[`_upsell_${variantId}`] = `${label}: ${name}`;
          });
          pending.clear();
          let kept = Object.keys(attributes).length;
          Object.keys(cart.attributes || {}).forEach((key) => {
            const match = key.match(/^_upsell_(\d+)$/);
            if (!match || key in attributes) return;
            if (items.has(match[1])) kept += 1;
            else attributes[key] = '';
          });
          hasRecords = kept > 0;
          if (!Object.keys(attributes).length) return;
          return fetch(`${routes.cart_update_url}.js`, { ...fetchConfig(), body: JSON.stringify({ attributes }) });
        })
        .catch((e) => console.error(e));
    }, 500)
  );
})();
